import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'ph-secondary-header',
    standalone: true,
    imports: [MatIconModule, MatButtonModule, TranslocoModule],
    templateUrl: './secondary-header.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class SecondaryHeaderComponent {
    @Input() titleKey = '';

    constructor(private _location: Location) {}

    back(): void {
        this._location.back();
    }
}
